import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    required: Boolean
  }
  static targets = ["checkbox", "error"]

  connect() {
    if (this.requiredValue) {
      // Find the form and listen for submit
      this.form = this.element.closest("form")
      this.form.addEventListener("submit", this.validate.bind(this))

      // Also clear error when user clicks any checkbox
      this.checkboxTargets.forEach(cb => {
        cb.addEventListener("change", () => this.hideError())
      })
    }
  }

  disconnect() {
    if (this.form) {
      this.form.removeEventListener("submit", this.validate.bind(this))
    }
  }

  validate(event) {
    if (!this.requiredValue) return

    const isAnyChecked = this.checkboxTargets.some(cb => cb.checked)

    if (!isAnyChecked) {
      event.preventDefault()
      this.showError()

      // Scroll to the error
      this.errorTarget.scrollIntoView({ behavior: "smooth", block: "center" })
    } else {
      this.hideError()
    }
  }

  showError() {
    this.errorTarget.classList.remove("hidden")
    // Optional: Add visual error state to container
    this.element.classList.add("border-red-300", "bg-red-50")
  }

  hideError() {
    this.errorTarget.classList.add("hidden")
    this.element.classList.remove("border-red-300", "bg-red-50")
  }
}
